import { render, staticRenderFns } from "./UMLVOUser.vue?vue&type=template&id=215a3003&scoped=true&"
import script from "./UMLVOUser.vue?vue&type=script&lang=js&"
export * from "./UMLVOUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215a3003",
  null
  
)

export default component.exports